import React, {useEffect, useRef, useState} from 'react';
import {FaEye, FaEyeSlash} from "react-icons/fa";
import {TbTableOptions} from "react-icons/tb";
import clsx from "clsx";

const DEFAULT_BUTTON_CLASS_NAME = "cursor-pointer absolute bottom-3.75 left-5";
const DEFAULT_MENU_CLASS_NAME = "absolute z-999 bg-white border border-gray-300 shadow rounded-md w-[256px] bottom-10 left-5 h-[calc(100vh-116px)] overflow-y-scroll";

const ShowHideColumnsGrid = ({
    columnDefs,
    toggleColumn,
    storageItem,
    wrapperClassName = "contents",
    buttonClassName = DEFAULT_BUTTON_CLASS_NAME,
    menuClassName = DEFAULT_MENU_CLASS_NAME,
}) => {
    const [showMenu, setShowMenu] = useState(false);
    const buttonMenuRef = useRef(null);
    const menuRef = useRef(null);

    useEffect(() => {
        if (storageItem && columnDefs.length) {
            const hiddenColumns = columnDefs.filter(c => c.hide).map(c => c.field);
            localStorage.setItem(storageItem, JSON.stringify(hiddenColumns));
        }
    }, [columnDefs, storageItem]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)
                && buttonMenuRef.current && !buttonMenuRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className={wrapperClassName}>
            <span ref={buttonMenuRef} title={"Configurações da tabela"} className={clsx(buttonClassName, DEFAULT_BUTTON_CLASS_NAME)}
                  onClick={() => setShowMenu(!showMenu)}>
                <TbTableOptions fontSize={24}/>
            </span>

            {
                showMenu &&
                <div ref={menuRef} className={clsx(menuClassName, DEFAULT_MENU_CLASS_NAME)}>
                    <div className="p-1.5 space-y-0.5">
                        {
                            columnDefs
                                .filter(c => c.field !== "")
                                .sort((a, b) =>
                                    String(a.headerName ?? "").localeCompare(String(b.headerName ?? ""), "pt-BR", {sensitivity: "base"})
                                )
                                .map((column, index) => {
                                    const visible = !column.hide;

                                    return (
                                        <div key={index}
                                             className={"flex items-center justify-between gap-2 rounded-md px-2 py-1.5 text-[14px] cursor-pointer transition-colors hover:bg-gray-100 " + (visible ? "font-medium text-gray-700" : "text-gray-400")}
                                             onClick={() => toggleColumn(column.field)}>
                                            <span className="truncate">{column.headerName}</span>
                                            {
                                                visible
                                                    ? <FaEye className="shrink-0 text-(--blue-dark)"/>
                                                    : <FaEyeSlash className="shrink-0 text-gray-400"/>
                                            }
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>
            }
        </div>
    );
};

export default ShowHideColumnsGrid;
